<template>
  <v-app>
    <v-content>
      <TocGenerator/>
    </v-content>
  </v-app>
</template>

<script>
import TocGenerator from './components/TocGenerator';

export default {
  name: 'App',
  components: {
    TocGenerator,
  }
};
</script>
